module.exports = __webpack_public_path__ + "img/icon-history-buy.beb62fff.svg";